// Loading skeleton for edit form pages (breadcrumb header with extra crumb,
// overview with image + form inputs, configurations card, footer with save
// button). Keep in sync with Components::Skeletons::Edit.

import {
  Bar,
  DetailFooter,
  DetailHeader,
  DEFAULT_LABEL,
  InputField,
  PageShell,
  TwoColumnInput,
} from './primitives';

export function EditSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <DetailHeader crumbs={3} />
      <div className="flex-1">
        <div className="w-full px-16 pt-8 pb-12 space-y-10">
          <section>
            <Bar className="h-[30px] w-32 mb-6" />
            <div className="flex gap-16">
              <Bar className="aspect-square w-edit-image shrink-0 rounded-input" />
              <div className="flex flex-1 flex-col gap-8">
                <InputField />
                <TwoColumnInput />
                <TwoColumnInput />
              </div>
            </div>
          </section>
          <section>
            <Bar className="h-[30px] w-44 mb-6" />
            <div className="rounded-input border border-dinnerplate-white p-6">
              <div className="flex flex-col gap-8">
                <TwoColumnInput />
                <TwoColumnInput />
              </div>
            </div>
          </section>
        </div>
      </div>
      <DetailFooter buttonClass="h-[42px] w-[131px]" />
    </PageShell>
  );
}
